import { HttpMethod, RequestMatcher } from '@ipensii/shared/domain-shared';

export const publicRequests: Array<RequestMatcher> = [
  { url: '/actuator/health' },
  { method: HttpMethod.GET, url: '/api/providers' },
  { method: HttpMethod.GET, url: '/api/component-info' },
  { url: '/api/onboarding-ext' },
  { url: '/api/auth/users/password-recovery-request' },
  { url: '/api/lead' },
];
